import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ProductOverview from "./pages/ProductOverview";
import DelayCostCalculator from "./pages/DelayCostCalculator";
import Charter from "./pages/Charter";
import Pricing from "./pages/Pricing";
import ComingSoon from "./pages/ComingSoon";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CancellationPolicy from "./pages/CancellationPolicy";
import NotFound from "./pages/NotFound";
// ResourceHub (/guides) is temporarily unrouted - its download form doesn't actually
// send anything yet (see audit). Re-add the import + route once it's wired to a real
// email/lead-capture backend.
import "./styles/tokens.css";

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tierup" element={<ProductOverview />} />
          <Route path="/charter" element={<Charter />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/calculator" element={<DelayCostCalculator />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cancellation" element={<CancellationPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
